import React from 'react'
import { MainBannerContent, MainBannerLogoWrapper, MainBannerTextWrapper, MainBannerWrapper } from './MainBannerStyled'
import { Container } from '../CommonStyled/CommonStyled'
import { useRecoilValue } from 'recoil'
import { breakPointState } from '../../recoil/commonState'
import { useNavigate } from 'react-router-dom'
import IMAGES from '../../images'
import { BREAKPOINT } from '../../constant'
import config from '../../config'
import ImageRender from '../ImageRender'
import { buildPath } from '../../utils/common'

const MainBanner = props => {
  const { data } = props
  const breakPoint = useRecoilValue(breakPointState)
  const navigate = useNavigate()

  return (
    data && (
      <MainBannerWrapper>
        {/*<img className={'banner-person'} src={IMAGES.BANNER_PERSON} alt={'person'} />*/}
        {/*<Container height={'100%'}>*/}
        {/*  <MainBannerContent>*/}
        {/*    <MainBannerTextWrapper>*/}
        {/*      <img className={'text-banner'} src={IMAGES.TEXT_BANNER} alt={'text-banner'} />*/}
        {/*    </MainBannerTextWrapper>*/}
        {/*    <MainBannerLogoWrapper>*/}
        {/*      <img className={'banner-vp'} src={IMAGES.VP_LOGO} alt={'vp'} />*/}
        {/*      <div className={'divider'}></div>*/}
        {/*      <img className={'banner-care'} src={IMAGES.CARE_LOGO} alt={'care'} />*/}
        {/*    </MainBannerLogoWrapper>*/}
        {/*  </MainBannerContent>*/}
        {/*</Container>*/}
        {
          (data?.headerConfig?.backgroundImages?.computer || data?.headerConfig?.backgroundImages?.tablet || data?.headerConfig?.backgroundImages?.mobile) &&
          <ImageRender
            width={'100%'}
            breakPoint={breakPoint}
            computer={buildPath(data?.headerConfig?.backgroundImages?.computer)}
            tablet={buildPath(data?.headerConfig?.backgroundImages?.tablet)}
            mobile={buildPath(data?.headerConfig?.backgroundImages?.mobile)}
          />
        }
      </MainBannerWrapper>
    )
  )
}

export default MainBanner
